import { Navigate, Route, Routes } from "react-router-dom";
import { ProfileViewPage } from "./pages/ProfileViewPage";
import { ProfileEditPage } from "./pages/ProfileEditPage";

export const ProfileNavigation = () => {
  return (
    <Routes>
      <Route path="view" element={<ProfileViewPage />} />
      <Route path="edit" element={<ProfileEditPage />} />
      <Route path="/*" element={<Navigate to="/app/profile/view" replace />} />
    </Routes>
  );
};
